import { useFormContext } from 'react-hook-form'
import renderer from './renderer'
import { ConnectFormProps } from './RouteWizard'

const ConnectForm = ({ children }: ConnectFormProps) => {
  const methods = useFormContext()
  return <>{renderer.renderChildren(children, methods)}</>
}

export default ConnectForm
